import { withJsonFormsControlProps, useJsonForms } from '@jsonforms/react';
import { updateErrors } from '@jsonforms/core';
import { UrlFileUploadField } from '../CustomComponents/UrlFileUploadField';
import type { ControlProps } from '@jsonforms/core';

type UrlFileUploadControlProps = ControlProps & {
  onChangeUpload?: (file: File) => Promise<string>;
};

const UrlFileUploadControl = ({
  data,
  handleChange,
  path,
  label,
  required,
  schema,
  onChangeUpload,
}: UrlFileUploadControlProps) => {
  const { dispatch } = useJsonForms();

  const sendError = (errorMessage: string | null) => {
    dispatch?.(
      updateErrors(
        errorMessage
          ? [
              {
                message: errorMessage,
                instancePath: path.startsWith('/') ? path : `/${path}`,
                keyword: 'custom',
                schemaPath: '',
                params: {},
              },
            ]
          : []
      )
    );
  };

  const options = (schema as any)?.['x-options'] || {};

  return (
    <UrlFileUploadField
      value={data}
      label={label ?? schema?.title}
      required={required}
      helperText={(schema as any)?.helperText}
      onChange={(newValue, error) => {
        handleChange(path, newValue);
        sendError(error);
      }}
      onChangeUpload={onChangeUpload}
      config={{
        urlLabel: options.urlLabel ?? 'URL',
        uploadButtonLabel: options.uploadButtonLabel ?? 'Upload File',
        fileDialogTitle: options.fileDialogTitle ?? 'Select File',
        fileDialogAccept: options.fileDialogAccept ?? 'image/*,video/*',
        maxFileSize: options.maxFileSize ?? 10,
      }}
      classes={{
        root: 'mb-4 text-mainText',
        input: 'bg-gray-50 text-small',
        label: 'text-medium',
        helperText: 'text-small italic',
        uploadButton: 'bg-blue-500 hover:bg-blue-600 text-white',
        previewContainer:
          'flex flex-col items-center gap-2 p-3 border rounded bg-gray-50',
        previewImage: 'w-20 h-20 object-cover rounded border',
        clearButton: 'text-red-500 hover:text-red-700',
        ...options.classes,
      }}
    />
  );
};

const UrlFileUploadControlWithProps = (props: any) => {
  const additionalProps = (window as any).__jsonFormsAdditionalProps || {};

  return (
    <UrlFileUploadControl
      {...props}
      onChangeUpload={additionalProps.onChangeUpload}
    />
  );
};

export default withJsonFormsControlProps(UrlFileUploadControlWithProps);
